import { defaultConfig } from "@web3modal/ethers";

export const GovernceLists = [
    {
        name: "Lock",
    },
    {
        name: "Vote",
    },
    {
        name: "Delegation",
    },
    {
        name: "Stats",
    },
];


export const projectId = '9f74cc0566155c71fc3f018048f6b4b9'

export const network = {
    chainId: 11155111,
    name: 'Ethereum Sepolia Testnet',
    currency: 'ETH',
    explorerUrl: 'https://sepolia.etherscan.io',
    rpcUrl: 'https://sepolia.drpc.org',
}

export const metadata = {
    name: 'Piku',
    description: 'Piku description',
    url: 'https://piku.com', // origin must match your domain & subdomain
    icons: ['https://avatars.mywebsite.com/']
}
export const ethersConfig = defaultConfig({
    metadata,
    enableEIP6963: true, // true by default
    enableInjected: true, // true by default
    enableCoinbase: true, // true by default
    rpcUrl: '...', // used for the Coinbase SDK
    defaultChainId: 1 // used for the Coinbase SDK
})
